export function assertIsDefined<T>(value: T): asserts value {
  if (!value) {
    throw new Error(`value not defined`);
  }
}
